import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Login } from "@/pages/Login";
import { ExternalEvaluationPage } from "@/features/Collaborators/PerformanceEvaluation/pages/ExternalEvaluationPage";
import { DayOffClientApprovalPage } from "@/features/DpRequests/pages/DayOffClientApprovalPage";
import { ClientApprovalPage } from "@/features/Vacations/pages/ClientApprovalPage";
import { CandidatoFormExternoPage, CandidatoFormExternoEtapa2Page } from "@/features/Recruitment/pages";

function RedirectToLogin() {
  const location = useLocation();
  const from = `${location.pathname}${location.search}${location.hash}`;
  const params = new URLSearchParams();

  if (from && from !== "/") {
    params.set("from", from);
  }

  const search = params.toString();
  return <Navigate to={`/login${search ? `?${search}` : ""}`} replace />;
}

export default function PublicRoutes() {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="evaluations/external/:token" element={<ExternalEvaluationPage />} />
      <Route path="ferias/cliente/:token" element={<ClientApprovalPage />} />
      <Route path="day-off/cliente/:token" element={<DayOffClientApprovalPage />} />
      <Route path="recruitment/candidato/:token" element={<CandidatoFormExternoPage />} />
      <Route path="recruitment/candidato/etapa2/:token" element={<CandidatoFormExternoEtapa2Page />} />
      <Route path="*" element={<RedirectToLogin />} />
    </Routes>
  );
}
